import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";
import { trackPageview } from "@/lib/api";

export const Layout = ({ children }) => {
  const loc = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    trackPageview(loc.pathname);
  }, [loc.pathname]);

  return (
    <div className="App flex min-h-screen flex-col">
      <a
        href="#main"
        className="sr-only focus:not-sr-only focus:absolute focus:z-[100] focus:top-2 focus:left-2 focus:bg-spruce focus:text-bone focus:px-4 focus:py-2"
      >
        Skip to content
      </a>
      <Header />
      <main id="main" className="flex-1">
        {children}
      </main>
      <Footer />
      <Toaster position="top-center" richColors />
    </div>
  );
};

export default Layout;
